import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFocusLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      d="M7.5 7.91667C7.5 7.68655 7.68655 7.5 7.91667 7.5H13.3333C14.0237 7.5 14.5833 6.94036 14.5833 6.25C14.5833 5.55964 14.0237 5 13.3333 5H7.91667C6.30584 5 5 6.30584 5 7.91667V13.3333C5 14.0237 5.55964 14.5833 6.25 14.5833C6.94036 14.5833 7.5 14.0237 7.5 13.3333V7.91667Z"
      fill="currentColor"
    />
    <path
      d="M26.6667 5C25.9763 5 25.4167 5.55964 25.4167 6.25C25.4167 6.94036 25.9763 7.5 26.6667 7.5H32.0833C32.3135 7.5 32.5 7.68655 32.5 7.91667V13.3333C32.5 14.0237 33.0596 14.5833 33.75 14.5833C34.4404 14.5833 35 14.0237 35 13.3333V7.91667C35 6.30584 33.6942 5 32.0833 5H26.6667Z"
      fill="currentColor"
    />
    <path
      d="M7.5 26.6667C7.5 25.9763 6.94036 25.4167 6.25 25.4167C5.55964 25.4167 5 25.9763 5 26.6667V32.0833C5 33.6942 6.30584 35 7.91667 35H13.3333C14.0237 35 14.5833 34.4404 14.5833 33.75C14.5833 33.0596 14.0237 32.5 13.3333 32.5H7.91667C7.68655 32.5 7.5 32.3135 7.5 32.0833V26.6667Z"
      fill="currentColor"
    />
    <path
      d="M35 26.6667C35 25.9763 34.4404 25.4167 33.75 25.4167C33.0596 25.4167 32.5 25.9763 32.5 26.6667V32.0833C32.5 32.3135 32.3135 32.5 32.0833 32.5H26.6667C25.9763 32.5 25.4167 33.0596 25.4167 33.75C25.4167 34.4404 25.9763 35 26.6667 35H32.0833C33.6942 35 35 33.6942 35 32.0833V26.6667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 16.7083V16.6667C25 13.9052 22.7614 11.6667 20 11.6667C17.2386 11.6667 15 13.9052 15 16.6667V16.7083C14.0491 16.9014 13.3333 17.7421 13.3333 18.75V24.5833C13.3333 25.7339 14.2661 26.6667 15.4167 26.6667H24.5833C25.7339 26.6667 26.6667 25.7339 26.6667 24.5833V18.75C26.6667 17.7421 25.9509 16.9014 25 16.7083ZM17.5 16.6667H22.5C22.5 15.286 21.3807 14.1667 20 14.1667C18.6193 14.1667 17.5 15.286 17.5 16.6667Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFocusLock;
